import { render } from "./AuthFrame.vue?vue&type=template&id=5681081e"
import script from "./AuthFrame.vue?vue&type=script&lang=js"
export * from "./AuthFrame.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/AuthFrame.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5681081e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5681081e', __exports__)) {
    api.reload('5681081e', __exports__)
  }
  
  module.hot.accept("./AuthFrame.vue?vue&type=template&id=5681081e", () => {
    api.rerender('5681081e', render)
  })

}


export default __exports__